import { translationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import { SharingToolsCardWrapperVariant1 } from '../../../SharingToolsCardWrapper';
import { PosterPreview } from '../PosterPreview';

export function QRPosterCardVariant1() {
	const { data, actions } = useSharingTools();

	return (
		<SharingToolsCardWrapperVariant1
			title={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.title')}
			description={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.description_variant1')}
			primaryActionOnClick={actions.navigateToPosters}
		>
			<PosterPreview posterTemplate={data.posters.template} />
		</SharingToolsCardWrapperVariant1>
	);
}
